module.exports = __webpack_public_path__ + "static/gomesuit-a2ed2d1004e939a0a09ac2be055051ac.png";